import { render, staticRenderFns } from "./ProformaDialog.vue?vue&type=template&id=bda60880&scoped=true"
import script from "./ProformaDialog.vue?vue&type=script&lang=js"
export * from "./ProformaDialog.vue?vue&type=script&lang=js"
import style0 from "./ProformaDialog.vue?vue&type=style&index=0&id=bda60880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda60880",
  null
  
)

export default component.exports